//cspell:ignore mensaje
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { CardSection, Flex, PhonePreviewWhatsApp } from '@/lib/v2/components';
import PhonePreviewWhatsAppV0 from '@/lib/v2/components/PhonePreviewWhatsApp/PhonePreviewWhatsAppV0';

import { useFeatureFlag } from '@/src/application/hooks/util/useFeatureFlag';

import { useWhatsAppSummaryMain } from './useWhatsAppSummaryMain';

import { atomGlobalLoadingAction } from '@/modules/CampaignsModule/atoms/actionEmailAtom';
import { atomCallbackReportSmsStep } from '@/modules/CampaignsModule/atoms/actionsAtom';
import { atomActionInfoSms } from '@/modules/CampaignsModule/atoms/actionSMSAtom';
import {
  atomCurrentWhatsAppTemplate,
  atomMediaUrl,
} from '@/modules/CampaignsModule/atoms/actionWhatsAppAtom';
import { SmsSummary } from '@/modules/CampaignsModule/components/actionManagement/SmsAction/components/SmsSummary';
import { useContentVariables } from '@/modules/CampaignsModule/components/actionManagement/WhatsAppAction/hooks/useContentVariables';
import { useExtractBodyFromJson } from '@/modules/CampaignsModule/components/actionManagement/WhatsAppAction/hooks/useExtractBodyFromJson';
import { ConfirmAction } from '@/modules/CampaignsModule/components/CampaignsModal/ConfirmAction';
import { useWhatsAppTemplate } from '@/modules/CampaignsModule/components/CampaignsModal/PhonePreviewModal/hooks/useWhatsAppTemplate';
import { SummarySkeleton } from '@/modules/CampaignsModule/components/SummaryAction/SummarySkeleton';
import { atomWhatsAppTemplateSelected } from '@/modules/ContactsModule/atoms/WhatsApp';

const WhatsAppSummaryMain = () => {
  const actionInfoWhatsApp = useAtomValue(atomActionInfoSms);
  const globalLoadingAction = useAtomValue(atomGlobalLoadingAction);
  const isTemplateV0Enabled = useFeatureFlag('enableWhatsAppTemplateV0');

  const {
    events: { handleConfirmAction, handleReportClick },
    state: { loading },
  } = useWhatsAppSummaryMain();

  const setCallbackReportSmsStep = useSetAtom(atomCallbackReportSmsStep);
  const selectedTemplate = useAtomValue(atomWhatsAppTemplateSelected);
  const mediaUrl = useAtomValue(atomMediaUrl);
  const setCurrentWhatsAppTemplate = useSetAtom(atomCurrentWhatsAppTemplate);

  const { parseAndReplaceContentVariables } = useContentVariables();
  const { convertToWhatsAppTemplate, getMediaUrl } = useWhatsAppTemplate();

  useEffect(() => {
    setCallbackReportSmsStep(() => handleReportClick);
  }, [setCallbackReportSmsStep, handleReportClick]);

  const bodyMessage = useExtractBodyFromJson(
    actionInfoWhatsApp?.mensaje,
    selectedTemplate?.variables
  );

  const parsedContent =
    typeof actionInfoWhatsApp?.mensaje === 'string'
      ? parseAndReplaceContentVariables(actionInfoWhatsApp.mensaje)
      : { isValid: false, body: '', mediaUrl: '' };

  const renderPhonePreview = () => {
    if (globalLoadingAction || Object.keys(actionInfoWhatsApp).length === 0) {
      return <PhonePreviewWhatsApp loading message="" />;
    }

    if (parsedContent.isValid && parsedContent.contentSid) {
      const { template, canUseTemplateV0 } = convertToWhatsAppTemplate(parsedContent);

      if (isTemplateV0Enabled && canUseTemplateV0 && template) {
        setCurrentWhatsAppTemplate(template);
        return <PhonePreviewWhatsAppV0 />;
      }

      const mediaUrlToUse = getMediaUrl(parsedContent);
      return <PhonePreviewWhatsApp mediaUrl={mediaUrlToUse} message={parsedContent.body} />;
    }

    return <PhonePreviewWhatsApp mediaUrl={mediaUrl} message={bodyMessage} />;
  };

  return (
    <>
      <div className="relative z-0 bg-white">
        <CardSection noPadding>
          <Flex column>
            <Flex itemAlignment="start">
              <div className="my-12 w-1/2 bg-white px-10">
                {globalLoadingAction ? <SummarySkeleton /> : <SmsSummary />}
              </div>
              <div className="grid min-h-[calc(100dvh-145px)] w-1/2 items-center justify-center bg-emblue-secondary-hover py-4">
                {
                  /* cspell:disable */
                  renderPhonePreview()
                  /* cspell:enable */
                }
              </div>
            </Flex>
          </Flex>
        </CardSection>
      </div>
      <ConfirmAction loading={loading} onConfirm={handleConfirmAction} />
    </>
  );
};

export default WhatsAppSummaryMain;
